import React from 'react';
import './BillingTable.scss';

export default ({ data }) => {
    return (
        <div className="billing-table-container">
            <table className="billing-table">
                <thead>
                    <tr>
                        <th>Billing Number</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        data.length > 0 ? data.map((item, i)=>{
                            return (
                                <tr key={'billing-table-row'+i}>
                                    <td>{i+1}</td>
                                    <td>{item.start_date}</td>
                                    <td>{item.end_date}</td>
                                </tr>
                            )
                        }) : <tr>
                                <td colSpan="3" className="no-data-row">No Data Found</td>
                            </tr>
                    }
                </tbody>
            </table>
        </div>
    );
}
